/** Display formatting shared across the Nutrition V2 screens — one source of truth so
 *  units never drift between the meal rows, the totals and the targets bar. */

export const GRAM = "גר׳";
export const KCAL = "קק״ל";
export const KCAL_SHORT = "קל׳";

const round1 = (n: number): number => Math.round((Number(n) || 0) * 10) / 10;

/** `48 גר׳` */
export const grams = (n: number): string => `${round1(n)} ${GRAM}`;

/** `1,645` */
export const num = (n: number): string => Math.round(Number(n) || 0).toLocaleString("he-IL");

/** `1,645 קק״ל` */
export const kcal = (n: number): string => `${num(n)} ${KCAL}`;

/** `360 קל׳` — the compact form used inside rows */
export const kcalShort = (n: number): string => `${num(n)} ${KCAL_SHORT}`;

/**
 * A serving's label, with its weight appended — unless the name already states it.
 * Food names come from the DB as things like "gram 100", and "gram 100 (100 גר׳)"
 * reads as noise.
 */
export const servingLabel = (serving: { servingName?: string; gramsPerServing?: number }): string => {
  const name = serving.servingName || "מנה";
  const g = serving.gramsPerServing;
  if (!g) return name;
  // already mentions the number (e.g. "gram 100", "פרוסה 35 גרם")
  if (new RegExp(`(^|\\D)${g}(\\D|$)`).test(name)) return name;
  return `${name} (${g} ${GRAM})`;
};
